export default __webpack_public_path__ + "static/media/girl_on_bike.cfdc6e70.png";